/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { Icon, ActionSheet, Tag, Button } from "antd-mobile";
import { intl } from "../../services/intlGlobalProvider";
import Color from "../../utils/Color";
import * as addOnSelectors from "../../selectors/addOn";
import * as variantSelectors from "../../selectors/variant";
import * as userSelectors from "../../selectors/user";
import * as _ from "underscore";
import "./index.css";

const StyledContainer = styled.div`
  position: relative;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  background: white;
`;

const StyledMainContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  background: ${Color.primaryBackgroundColor};
  padding: 15px;
`;

const StyledImageContainer = styled.div`
  width: 28%;
`;

const StyledContentContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
`;

const StyledSideInfoContainer = styled.div`
  width: 22%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
`;

const StyledContentTitle = styled.span`
  text-align: start;
  color: black;
  font-size: 0.9em;
`;

const StyledContentSubtitle = styled.span`
  color: gray;
  font-size: 0.8em;
`;

const StyledContentDes = styled.span`
  color: ${Color.Secondary};
  font-size: 0.75em;
`;

const StyledMenuContainer = styled.div`
  cursor: pointer;
  padding: 0 5px;
  margin-top: -5px;
`;

const StyledPrice = styled.span`
  margin-top: 5px;
  font-size: 0.8em;
  color: black;
`;

const StyledDiscount = styled.span`
  margin-top: 5px;
  font-size: 0.8em;
  color: red;
`;

const StyledDeliveryContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  padding: 10px 15px;
  justify-content: space-between;
  align-items: center;
`;

const StyledDeliveryIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledDeliveryTitle = styled.span`
  margin-left: 12px;
  font-size: 0.9em;
  color: ${props =>
    props.isDelivery ? Color.favouriteColor : Color.disabledColor};
`;

const StyledDeliverySelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const StyledDeliverySelectionPrice = styled.span`
  margin-left: 8px;
  font-size: 0.9em;
  color: ${props => (props.isDelivery ? "black" : Color.disabledColor)};
`;

const StyledRadioButton = styled.div`
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid ${Color.favouriteColor};
`;

const StyledRadioSelected = styled.div`
  background: ${props => (props.isDelivery ? Color.favouriteColor : "white")}
  width: 6px;
  height: 6px;
  border-radius: 50%;
`;

const StyledNotAvailableContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const StyledNotAvailableTitle = styled.span`
  color: white;
  font-size: 1.1em;
`;

const StyledNotAvailableButton = styled(Button)`
  margin-top: 10px;
  && {
    :before {
     border: none !important;
    }
    cursor: pointer;
    font-size: 0.9em
    border-radius: 2px;
    padding: 8px 15px;
    height: auto;
    line-height: unset;
    color: white;
    background-color: ${Color.highlightRedTextColor};
  }
`;

const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault()
  };
}

class CartItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formattedAddOnText = addOn => {
    const addOnTitle = addOnSelectors.getAddOnName(addOn);
    const addOnQuantity = addOnSelectors.getAddOnQuantity(addOn);
    if (addOnQuantity > 0) {
      return `+${addOnQuantity}x ${addOnTitle}`;
    } else {
      return false;
    }
  };

  formattedVariantText = variant => {
    const variantTitle = variantSelectors.getVariantName(variant);
    const variantItems = variantSelectors.getVariantItems(variant);
    let variantItem = variantItems
      ? variantItems.find(variantItem => {
          const selectedVariant = variantSelectors.getVariantItemIsSelected(
            variantItem
          );
          if (selectedVariant) {
            return variantItem;
          }
        })
      : false;
    const variantItemName = variantSelectors.getVariantItemName(variantItem);
    return `${variantTitle} - ${variantItemName}`;
  };

  showActionSheet = foodId => {
    const BUTTONS = [
      intl.formatMessage({ id: "app.edit" }),
      intl.formatMessage({ id: "app.delete" }),
      intl.formatMessage({ id: "app.cancel" })
    ];

    ActionSheet.showActionSheetWithOptions(
      {
        options: BUTTONS,
        cancelButtonIndex: BUTTONS.length - 1,
        destructiveButtonIndex: BUTTONS.length - 2,
        maskClosable: true,
        "data-seed": "logId",
        wrapProps
      },
      buttonIndex => {
        switch (buttonIndex) {
          case 0:
            this.onEditFood(foodId);
            break;
          case 1:
            this.onDeleteFood(foodId);
            break;
        }
      }
    );
  };

  onEditFood = foodId => {
    const { onEditItem } = this.props;

    onEditItem && onEditItem(foodId);
  };

  onDeleteFood = foodId => {
    const { onDeleteItem } = this.props;

    onDeleteItem && onDeleteItem(foodId);
  };

  onDeliveryPressed = (foodId, isDelivery) => {
    const { onDeliveryPressed } = this.props;

    onDeliveryPressed && onDeliveryPressed(foodId, isDelivery);
  };

  render() {
    const { item } = this.props;
    const foodId = userSelectors.getUserCartItemStallItemID(item);
    const foodImageLarge = userSelectors.getUserCartItemStallItemImageLargeSrc(
      item
    );
    const quantity = userSelectors.getUserCartItemStallItemQuantity(item);
    const title = userSelectors.getUserCartItemStallItemTitle(item);
    const variants = userSelectors.getUserCartItemStallItemVariants(item);
    const addOns = userSelectors.getUserCartItemStallItemAddOns(item);
    const addOnItems = addOns.filter(addOnItem => {
      return parseInt(addOnItem.quantity) > 0;
    });
    const totalDelivery = userSelectors.getUserCartItemStallItemTotalDeliveryWithCurrency(
      item
    );
    const totalPrice = userSelectors.getUserCartItemStallItemTotalPriceWithCurrency(
      item
    );
    const isDelivery = userSelectors.getUserCartItemStallItemIsDelivery(item);
    const isTakeAway = userSelectors.getUserCartItemStallItemIsTakeAway(item);
    const isAllowDelivery = userSelectors.getUserCartItemStallItemIsAllowDelivery(
      item
    );
    const isCheckoutable = userSelectors.getUserCartItemStallItemIsCheckoutable(
      item
    );
    const cartItemDiscount = userSelectors.getUserCartItemDiscount(item);
    const cartItemCurrency = userSelectors.getUserCartItemStallItemCurrencySymbol(
      item
    );

    return (
      <StyledContainer>
        {!isCheckoutable ? (
          <StyledNotAvailableContainer>
            <StyledNotAvailableTitle>
              <FormattedMessage
                id="cart.order.item.checkout.not.available.title"
                defaultMessage="Not available now"
                description="Cart Order Item Not Available Title"
              />
            </StyledNotAvailableTitle>
            <StyledNotAvailableButton
              onClick={() => this.onDeleteFood(foodId)}
              activeStyle={{
                backgroundColor: Color.activeHighlightRedTextColor
              }}
            >
              <FormattedMessage
                id="cart.order.item.checkout.not.available.button.title"
                defaultMessage="Remove"
                description="Cart Order Item Button Not Available Title"
              />
            </StyledNotAvailableButton>
          </StyledNotAvailableContainer>
        ) : (
          false
        )}
        <StyledMainContainer>
          <StyledImageContainer>
            <img
              ref={ref => (this.itemImage = ref)}
              src={
                foodImageLarge
                  ? foodImageLarge
                  : "https://via.placeholder.com/100x100"
              }
              alt=""
              style={{
                width: "100%",
                objectFit: "cover",
                objectPosition: "center"
              }}
              onLoad={() => {
                window.dispatchEvent(new Event("resize"));
              }}
            />
          </StyledImageContainer>
          <StyledContentContainer>
            <StyledContentTitle>
              {quantity}x {title}
            </StyledContentTitle>
            {!_.isEmpty(variants) ? (
              <StyledContentSubtitle style={{ marginTop: "4px" }}>
                <FormattedMessage id="cart.order.item.variant.title" />
              </StyledContentSubtitle>
            ) : null}
            {!_.isEmpty(variants)
              ? variants.map((variant, index) => {
                  return (
                    <StyledContentDes key={index}>
                      {this.formattedVariantText(variant)}
                    </StyledContentDes>
                  );
                })
              : null}
            {!_.isEmpty(addOnItems) ? (
              <StyledContentSubtitle style={{ marginTop: "4px" }}>
                <FormattedMessage id="cart.order.item.addon.title" />
              </StyledContentSubtitle>
            ) : null}
            {!_.isEmpty(addOnItems)
              ? addOnItems.map((addon, index) => {
                  return (
                    <StyledContentDes key={index}>
                      {this.formattedAddOnText(addon)}
                    </StyledContentDes>
                  );
                })
              : null}
          </StyledContentContainer>
          <StyledSideInfoContainer>
            <StyledMenuContainer
              className={"opacity"}
              onClick={() => this.showActionSheet(foodId)}
            >
              <Icon type="ellipsis" size="xs" color="gray" />
            </StyledMenuContainer>
            <StyledPrice>{totalPrice}</StyledPrice>
            {cartItemDiscount && cartItemDiscount !== 0 ? (
              <StyledDiscount>
                - {cartItemCurrency} {cartItemDiscount}
              </StyledDiscount>
            ) : (
              false
            )}
            <Tag
              disabled
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                height: "auto",
                lineHeight: "unset",
                padding: "5px",
                fontSize: "0.8em",
                border: "unset",
                marginTop: "5px",
                color: "white",
                background: isTakeAway
                  ? Color.takeAwayLabelColor
                  : Color.Primary
              }}
            >
              {intl.formatMessage({
                id: isTakeAway
                  ? "cart.order.item.take.away.title"
                  : "cart.order.item.dine.in.title"
              })}
            </Tag>
          </StyledSideInfoContainer>
        </StyledMainContainer>
        {isAllowDelivery && isCheckoutable ? (
          <StyledDeliveryContainer
            onClick={() => this.onDeliveryPressed(foodId, isDelivery)}
          >
            <StyledDeliveryIconContainer>
              <img
                src={require("../../assets/icons/delivery.png")}
                style={{ width: "18px" }}
              />
              <StyledDeliveryTitle isDelivery={isDelivery}>
                {intl.formatMessage({ id: "cart.order.item.delivery.title" })}
              </StyledDeliveryTitle>
            </StyledDeliveryIconContainer>
            <StyledDeliverySelectionContainer>
              <StyledDeliverySelectionPrice isDelivery={isDelivery}>
                {totalDelivery}
              </StyledDeliverySelectionPrice>
              <StyledRadioButton>
                <StyledRadioSelected isDelivery={isDelivery} />
              </StyledRadioButton>
            </StyledDeliverySelectionContainer>
          </StyledDeliveryContainer>
        ) : null}
      </StyledContainer>
    );
  }
}

CartItem.propTypes = {
  item: PropTypes.object.isRequired,
  onEditItem: PropTypes.func.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  onDeliveryPressed: PropTypes.func.isRequired
};

export default CartItem;



// WEBPACK FOOTER //
// ./src/components/CartItem/index.js